import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Select from "react-select";
import { Select as Myselect } from "antd";
import { all_routes } from "../../Router/all_routes";
import Addunits from "../../core/modals/inventory/addunits";
import AddBrand from "../../core/modals/inventory/addbrand";
import {
  ArrowLeft,
  ChevronDown,
  PlusCircle,
  Info,
  List,
} from "feather-icons-react/build/IconComponents";
import Axios from "axios";
import {
  API_BASE_URL,
  GET_VSTORE_PROD,
  GET_TAXES_DATA,
  INSERT_PROD,
  PRODUCT_IMAGE_UPLOAD,
  GET_USER_STORES,
  IMAGE_URL_IBIZ,
} from "../../Config";
import Swal from "sweetalert2";
import AddCategoryList from "../../core/modals/inventory/addcategorylist";
import AddSubcategory from "../../core/modals/inventory/addsubcategory";
import AddVariant from "../../core/modals/inventory/addvariant";
import { useLocation } from "react-router-dom";
import qs from "qs";
import SpinLoader from "../loader/SpinLoader";

const EditProduct = () => {
  const location = useLocation();
  const query = qs.parse(location.search, { ignoreQueryPrefix: true });
  const productId = query.id;
  const navigate = useNavigate();
  const [userDataSession, setUserDataSession] = useState([]);
  const [brandSelectedValue, setBrandSelectedValue] = useState(null);
  const [purchaseUnitSelectedValue, setPurchaseUnitSelectedValue] =
    useState(null);
  const [saleUnitSelectedValue, setSaleUnitSelectedValue] = useState(null);
  const [categorySelectedValue, setCategorySelectedValue] = useState(null);
  const [subCategorySelectedValue, setSubCategorySelectedValue] =
    useState(null);
  const route = all_routes;

  const [categoryData, setCategoryData] = useState([]);
  const [subCategoryData, setSubCategoryData] = useState([]);
  const [userStores, setUserStores] = useState([]);
  const [variantTypeData, setVariantTypeData] = useState([]);
  const [submitBtnLoading, setSubmitBtnLoading] = useState(false);
  // const [selectedWeight, setSelectedWeight] = useState("");
  const [storeEditFormData, setStoreEditFormData] = useState([]);
  const [selectedVType, setSelectedVType] = useState([]);
  const [getStoreProducts, setGetStoreProducts] = useState([]);
  const [unitsData, setUnitsData] = useState([]);
  const [brandsData, setBrandsData] = useState([]);
  const [taxesData, setTaxesData] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [dataLoading, setDataLoading] = useState(false);

  useEffect(() => {
    const variantypesData = JSON.parse(
      sessionStorage.getItem("filteredDDLData_variantypes")
    );
    const unitsData = JSON.parse(
      sessionStorage.getItem("filteredDDLData_UNITS")
    );
    const brandsData = JSON.parse(
      sessionStorage.getItem("filteredDDLData_BRAND")
    );
    const categoryDatas = JSON.parse(
      sessionStorage.getItem("filteredDDLData_CATEGORY")
    );
    const subcategoryData = JSON.parse(
      sessionStorage.getItem("filteredDDLData_Subcategories")
    );
    const userDataString = sessionStorage.getItem("userData");

    if (userDataString) {
      const userData = JSON.parse(userDataString);
      setUserDataSession(userData);
      setCategoryData(categoryDatas);
      setSubCategoryData(subcategoryData);
      setVariantTypeData(variantypesData);
      setUnitsData(unitsData);
      setBrandsData(brandsData);
    } else {
      console.log("User data not found in sessionStorage");
    }
  }, []);
  console.log(variantTypeData, "variant type data in edit");
  useEffect(() => {
    console.log(productId, "product Id from params for edit..");

    if (productId && userDataSession?.OrgId) {
      const fetchData = async () => {
        setDataLoading(true);
        console.log("Before fetching edit product details", new Date().toLocaleString())
        try {
          const response = await Axios.post(
            `${API_BASE_URL}${GET_VSTORE_PROD}`,
            {
              OrgId: userDataSession.OrgId,
              CategoryId: 0,
              BarCode: "0",
              IsActive: 1,
              ProductId: productId,
              StoreId: 0,
              IsForSale: 1,
              UserId: userDataSession.UserId,
              Type: 1,
            }
          );
          console.log(response.data.ResultData, "list of store products ");
          setGetStoreProducts(response.data.ResultData);
        } catch (error) {
          console.log(error);
        } finally {
          setDataLoading(false);
           console.log("After fetching edit product details", new Date().toLocaleString())
        }
      };
      fetchData();
    }
  }, [userDataSession, productId]);

  useEffect(() => {
    if (userDataSession && userDataSession.OrgId) {
      Axios.get(
        `${API_BASE_URL}${GET_USER_STORES}?OrgId=${userDataSession.OrgId}&UserId=${userDataSession.UserId}`
      )
        .then((response) => {
          if (response.data) {
            setUserStores(response.data.ResultData);
          } else {
            console.error("Error fetching data:", response.data);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    }
  }, [userDataSession]);

  useEffect(() => {
    if (userDataSession && userDataSession.OrgId) {
      Axios.get(
        `${API_BASE_URL}${GET_TAXES_DATA}?OrgId=${userDataSession.OrgId}`
      )
        .then((response) => {
          if (response.data.Status) {
            setTaxesData(response.data.ResultData);
          } else {
            console.error("Error fetching data:", response.data);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    }
  }, [userDataSession]);

  useEffect(() => {
    if (userStores && getStoreProducts && getStoreProducts.length > 0) {
      const initialStoreData = userStores.map((store) => {
        const matchedProduct = getStoreProducts.find(
          (product) => product.StoreId == store.StoreId
        );

        return {
          Id: matchedProduct?.StoreProductId || 0,
          StoreId: store.StoreId,
          IsForSale: matchedProduct?.IsForSale || false,
          StorePrice: matchedProduct?.StorePrice || "",
          LowStock: matchedProduct?.LowStock || "",
          OptimalStock: matchedProduct?.OptimalStock || "",
          InStock: matchedProduct?.InStock || "",
          addAdjStock: matchedProduct?.addAdjStock || "",
          PriceInclusiveTax: matchedProduct?.PriceInclusiveTax || false,
          taxId: matchedProduct?.TaxId || "",
        };
      });
      setStoreEditFormData(initialStoreData);
    }
  }, [userStores, getStoreProducts]);

  const [editformData, setEditFormData] = useState({
    Id: "",
    BrandId: "",
    PurchaseUnitId: "",
    SaleUnitId: "",
    CategoryId: "",
    SubCategoryId: "",
    BarCode: "",
    Name: "",
    Description: "",
    AvgPrice: "",
    ImagePath: "",
    ImageUrl: "",
    TrackStock: "",
    IsCompositeItem: "",
    StoreWiseTaxes: "",
    IsActive: 1,
    CreatedBy: "",
    UpdatedBy: "",
    SoldbyWeight: "",
    ProductSKU: "",
    HSN: "",
    Weight: "",
    PackingWeight: "",
    code: "",
    MRP: "",
    ManufacturedDate: "",
    ExpiredDate: "",
  });

  useEffect(() => {
    if (getStoreProducts && getStoreProducts.length > 0) {
      const firstProduct = getStoreProducts[0];
      setEditFormData({
        Id: firstProduct.Id,
        BrandId: firstProduct.BrandId,
        PurchaseUnitId: firstProduct.PurchaseUnitId,
        SaleUnitId: firstProduct.SaleUnitId,
        CategoryId: firstProduct.CategoryId,
        SubCategoryId: firstProduct.SubcategoryId,
        BarCode: firstProduct.BarCode,
        Name: firstProduct.ProductName,
        Description: firstProduct.Description,
        AvgPrice: firstProduct.AvgPrice,
        ImagePath: firstProduct.ImagePath,
        ImageUrl: firstProduct.ImageUrl,
        TrackStock: firstProduct.TrackStock,
        IsCompositeItem: firstProduct.IsCompositeItem,
        StoreWiseTaxes: firstProduct.StoreWiseTaxes,
        IsActive: 1,
        CreatedBy: userDataSession.UserId,
        UpdatedBy: userDataSession.UserId,
        SoldbyWeight: firstProduct.SoldbyWeight,
        ProductSKU: firstProduct.ProductSKU,
        HSN: firstProduct.HSN,
        Weight: firstProduct.Weight,
        PackingWeight: firstProduct.PackingWeight,
        code: firstProduct.code,
        MRP: firstProduct.MRP,
        ManufacturedDate: "",
        ExpiredDate: "",
      });

      // Set selected values based on fetched data
      setBrandSelectedValue(firstProduct.BrandId);
      setPurchaseUnitSelectedValue(firstProduct.PurchaseUnitId);
      setSaleUnitSelectedValue(firstProduct.SaleUnitId);
      setCategorySelectedValue(firstProduct.CategoryId);
      setSubCategorySelectedValue(firstProduct.SubcategoryId);

      // Parse and set selected variant types based on VariantId
      if (firstProduct.VariantId) {
        const variantIds = firstProduct.VariantId.split(",").map((id) =>
          parseInt(id.trim(), 10)
        );
        const selectedVariants = variantTypeData
          .filter((v) => variantIds.includes(v.ItemId))
          .map((v) => ({
            value: v.ItemId,
            label: v.ItemValue,
          }));
        setSelectedVType(selectedVariants.length > 0 ? selectedVariants : []);
      } else {
        setSelectedVType([]);
      }
    }
  }, [getStoreProducts, userDataSession, variantTypeData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEditFormData((prevState) => {
      const newState = {
        ...prevState,
        [name]: value,
      };
      return newState;
    });
  };

  const handleBrandSelectChange = (selectedOption) => {
    editformData.BrandId = selectedOption;
    setBrandSelectedValue(selectedOption);
  };
  const getFirstLetter = (str) => {
    const match = str.match(/[a-zA-Z]/);
    return match ? match[0].toUpperCase() : "N/A";
  };
  const handlePurUnitSelectChange = (selectedOption) => {
    editformData.PurchaseUnitId = selectedOption;
    setPurchaseUnitSelectedValue(selectedOption);
  };

  const handleSaleUnitSelectChange = (selectedOption) => {
    editformData.SaleUnitId = selectedOption;
    setSaleUnitSelectedValue(selectedOption);
  };

  const handleCatSelectChange = (selectedOption) => {
    editformData.CategoryId = selectedOption;
    setCategorySelectedValue(selectedOption);
  };

  const handleSubCatSelectChange = (selectedOption) => {
    editformData.SubCategoryId = selectedOption;
    setSubCategorySelectedValue(selectedOption);
  };

  const handleVariantTypeSelectChange = (selectedOption) => {
    setSelectedVType(selectedOption);
  };

  const handleSoldByChange = (event) => {
    const { name } = event.target;
    if (name === "each") {
      setEditFormData((prevState) => ({
        ...prevState,
        SoldbyWeight: false, // Set to false when "Each" is checked
      }));
    } else if (name === "weight") {
      setEditFormData((prevState) => ({
        ...prevState,
        SoldbyWeight: true, // Set to true when "Weight" is checked
      }));
    }
  };

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    setEditFormData((prevState) => ({
      ...prevState,
      [name]: checked ? true : false,
    }));
  };
  const handlePriceIncTaxCheckbox = (index) => (event) => {
    const { checked } = event.target;
    setStoreEditFormData((prevState) => {
      const updatedData = [...prevState];
      updatedData[index] = {
        ...updatedData[index],
        PriceInclusiveTax: checked,
      };
      return updatedData;
    });
  };

  const handleCompositeCheckbox = (event) => {
    const { name, checked } = event.target;
    setEditFormData((prevState) => ({
      ...prevState,
      [name]: checked ? true : false,
    }));
  };

  const handleForSaleCheckbox = (index) => (event) => {
    const { checked } = event.target;
    const updatedStoreData = [...storeEditFormData];

    // Update the specific index with the new 'IsForSale' value
    updatedStoreData[index] = {
      ...updatedStoreData[index],
      IsForSale: checked,
    };

    // Update the state with the modified store data
    setStoreEditFormData(updatedStoreData);
  };

  const handleStorePriceChange = (index, event) => {
    const { value } = event.target;

    setStoreEditFormData((prevState) => {
      const updatedData = [...prevState];
      updatedData[index] = {
        ...updatedData[index],
        StorePrice: value, // update the specific index
      };
      return updatedData;
    });
  };

  const handleStoreCheckboxChange = (index, field) => (event) => {
    const { value } = event.target; // value is now the Id directly

    setStoreEditFormData((prevState) => {
      const updatedData = [...prevState];
      updatedData[index] = {
        ...updatedData[index],
        [field]: value, // Store the Id directly
      };
      return updatedData;
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitBtnLoading(true);
    console.log(storeEditFormData, "stores data edited densing data");

    editformData.CategoryId = categorySelectedValue;
    editformData.SubCategoryId = subCategorySelectedValue;
    editformData.BrandId = brandSelectedValue;
    editformData.PurchaseUnitId = purchaseUnitSelectedValue;
    editformData.SaleUnitId = saleUnitSelectedValue;
    editformData.UpdatedBy = userDataSession.UserId;
    console.log(storeEditFormData, "store edit form data");
    const payload = {
      orgid: userDataSession.OrgId,
      userid: userDataSession.UserId,
      Product: {
        ...editformData,
      },
      StoreProduct: storeEditFormData

        .filter((store) => store.IsForSale)
        .map((store) => {
          const inStock = parseFloat(store.InStock) || 0;
          const addAdjStock = parseFloat(store.addAdjStock) || 0;
          const price = parseFloat(store.StorePrice) || 0;
          const optimalStock = parseFloat(store.OptimalStock) || 0;
          const lowStock = parseFloat(store.LowStock) || 0;
          const taxId = store.taxId ? JSON.parse(Number(store.taxId)) : null;

          return {
            Id: store.Id,
            StoreId: store.StoreId,
            Prices: price,
            VendorId: 0,
            IsActive: 1,
            InStock: inStock + addAdjStock,
            OptimalStock: optimalStock,
            TaxId: taxId || null,
            LowStock: lowStock,
            IsForSale: store.IsForSale,
            PriceInclusiveTax: store.PriceInclusiveTax ? 1 : 0,
          };
        }),
      ProductVariants: [
        {
          Id: 0,
          VariantTypeId: selectedVType.value,
          Value: "25.0",
          IsActive: 1,
          CalcVal: 1,
        },
      ],
      OperationType: "Update",
    };

    console.log(payload, "payload data before api sending");

    try {
      const response = await fetch(`${API_BASE_URL}${INSERT_PROD}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        const data = await response.json();
        console.log(data);

        if (data[0].Success === 1) {
          if (selectedFile) {
            const formData = new FormData();
            formData.append("OrgId", userDataSession.OrgId);
            formData.append("ProductId", editformData.Id);
            formData.append("file", selectedFile);

            const imageResponse = await fetch(
              `${API_BASE_URL}${PRODUCT_IMAGE_UPLOAD}`,
              {
                method: "POST",
                body: formData,
              }
            );

            if (imageResponse.ok) {
              const imageData = await imageResponse.json();
              console.log("Image uploaded successfully", imageData);
            } else {
              console.error("Failed to upload image");
            }
          }

          Swal.fire({
            title: `Product updated Successfully.`,
            icon: "success",
          }).then((result) => {
            if (result.isConfirmed || result.isDismissed) {
            navigate("/product-list", { state: { refresh: true } });
            }
          });
        } else {
          setSubmitBtnLoading(false);
          Swal.fire({
            title: "Error",
            text: "Failed to update product.",
            icon: "error",
          });
        }
      }
    } catch (error) {
      navigate("/product-list");
      console.error("Error:", error);
    } finally {
      setSubmitBtnLoading(false);
    }
  };

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  // const customStyles = {
  //   control: (provided) => ({
  //     ...provided,
  //     minHeight: "2rem",
  //     height: "2.4rem",
  //   }),
  //   valueContainer: (provided) => ({
  //     ...provided,
  //     height: "1rem",
  //     padding: "0 6px",
  //   }),
  //   input: (provided) => ({
  //     ...provided,
  //     margin: "0",
  //   }),
  // };

  const [isHovered, setIsHovered] = useState(false);

  const imageStyle = {
    width: "50px",
    height: "50px",
    objectFit: "cover",
    marginRight: "10px",
    borderRadius: "50%",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    transform: isHovered ? "scale(1.1)" : "scale(1)",
    transition: "0.3s ease-in-out",
  };

  return (
    <>
      {dataLoading && <SpinLoader />}
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Edit Product</h4>
                <h6>Manage product</h6>
              </div>
            </div>
            <ul className="table-top-head">
              <li>
                <div className="page-btn">
                  <Link to={route.productlist} className="btn btn-secondary">
                    <ArrowLeft className="me-2" />
                    Back to Product
                  </Link>
                </div>
              </li>
            </ul>
          </div>
          {/* /Edit */}
          <form onSubmit={handleSubmit}>
            <div className="card">
              <div className="card-body add-product pb-0">
                <div
                  className="accordion-card-one accordion"
                  id="accordionExample"
                >
                  <div className="accordion-item">
                    <div className="accordion-header" id="headingOne">
                      <div
                        className={`accordion-button ${
                          [1, 2, 4].includes(userDataSession.RoleId)
                            ? ""
                            : "d-none"
                        }`}
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOne"
                        aria-controls="collapseOne"
                      >
                        <div className="addproduct-icon">
                          <h5>
                            <Info className="add-info" />

                            <span>Product Information</span>
                          </h5>
                          <Link to="#">
                            <ChevronDown className="chevron-down-add" />
                          </Link>
                        </div>
                      </div>
                    </div>
                    <div
                      id="collapseOne"
                      className={`accordion-collapse collapse show ${
                        [1, 2, 4].includes(userDataSession.RoleId)
                          ? ""
                          : "d-none"
                      }`}
                      aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        <div className="row">
                          <div className="col-lg-4 col-sm-6 col-12">
                            <div className="mb-3 add-product">
                              <label className="form-label">Product Name</label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Product name"
                                name="Name"
                                value={editformData.Name || ""}
                                onChange={handleChange}
                              />
                            </div>
                          </div>
                          <div className="col-lg-4 col-sm-6 col-12">
                            <div className="mb-3 add-product">
                              <label className="form-label">Barcode</label>
                              <input
                                className="form-control"
                                type="text"
                                placeholder="Enter barcode"
                                name="BarCode"
                                minLength={5}
                                value={editformData.BarCode || ""}
                                onChange={handleChange}
                              />
                            </div>
                          </div>
                          <div className="col-lg-4 col-sm-6 col-12">
                            <div className="input-blocks add-product list">
                              <label>MRP</label>
                              <input
                                type="text"
                                className="form-control list"
                                placeholder="Enter MRP"
                                name="MRP"
                                value={editformData.MRP || ""}
                                onChange={handleChange}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="addservice-info">
                          <div className="row">
                            <div className="col-lg-4 col-sm-6 col-12">
                              <div className="input-blocks">
                                <label>Brand</label>
                                <div className="row">
                                  <div className="col-lg-10 col-sm-10 col-10">
                                    <Myselect
                                      className="w-100 h-100"
                                      options={brandsData?.map((store) => ({
                                        value: store.ItemId,
                                        label: store.ItemValue,
                                      }))}
                                      placeholder="Choose Brand"
                                      onChange={handleBrandSelectChange}
                                      value={editformData.BrandId || null}
                                    />
                                  </div>
                                  <div className="col-lg-2 col-sm-2 col-2 ps-0">
                                    <div className="add-icon">
                                      <Link
                                        to="#"
                                        data-bs-toggle="offcanvas"
                                        data-bs-target="#offcanvasRightBrandAdd"
                                        aria-controls="offcanvasRightBrandAdd"
                                      >
                                        <PlusCircle className="plus" />
                                      </Link>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-4 col-sm-6 col-12">
                              <div className="input-blocks">
                                <label>Category</label>
                                <div className="row">
                                  <div className="col-lg-10 col-sm-10 col-10">
                                    <Myselect
                                      className="w-100 h-100"
                                      options={categoryData?.map((store) => ({
                                        value: store.ItemId,
                                        label: store.ItemValue,
                                      }))}
                                      onChange={handleCatSelectChange}
                                      placeholder="Choose Category"
                                      value={editformData.CategoryId || null}
                                    />
                                  </div>
                                  <div className="col-lg-2 col-sm-2 col-2 ps-0">
                                    <div className="add-icon">
                                      <Link
                                        to="#"
                                        data-bs-toggle="offcanvas"
                                        data-bs-target="#offcanvasRightCategoryAdd"
                                        aria-controls="offcanvasRightCategoryAdd"
                                      >
                                        <PlusCircle className="plus" />
                                      </Link>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-4 col-sm-6 col-12">
                              <div className="input-blocks">
                                <label>Sub Category</label>
                                <div className="row">
                                  <div className="col-lg-10 col-sm-10 col-10">
                                    <Myselect
                                      className="w-100 h-100"
                                      options={subCategoryData?.map(
                                        (store) => ({
                                          value: store.ItemId,
                                          label: store.ItemValue,
                                        })
                                      )}
                                      onChange={handleSubCatSelectChange}
                                      placeholder="Choose Subcategory"
                                      value={
                                        editformData?.SubCategoryId || null
                                      }
                                    />
                                  </div>
                                  <div className="col-lg-2 col-sm-2 col-2 ps-0">
                                    <div className="add-icon">
                                      <Link
                                        to="#"
                                        data-bs-toggle="offcanvas"
                                        data-bs-target="#offcanvasRightSubCategoryAdd"
                                        aria-controls="offcanvasRightSubCategoryAdd"
                                      >
                                        <PlusCircle className="plus" />
                                      </Link>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="add-product-new">
                          <div className="row">
                            <div className="col-lg-4 col-sm-6 col-12">
                              <div className="mb-3 add-product">
                                <label className="form-label">HSN</label>
                                <input
                                  className="form-control"
                                  type="text"
                                  placeholder="Enter HSN"
                                  name="HSN"
                                  value={editformData.HSN || ""}
                                  onChange={handleChange}
                                />
                              </div>
                            </div>
                            <div className="col-lg-4 col-sm-6 col-12">
                              <div className="mb-3 add-product">
                                <label className="form-label">Code</label>
                                <input
                                  className="form-control"
                                  type="text"
                                  maxLength={8}
                                  placeholder="Enter product code"
                                  name="code"
                                  value={editformData.code || ""}
                                  onChange={handleChange}
                                />
                              </div>
                            </div>
                            <div className="col-lg-4 col-sm-6 col-12">
                              <div className="mb-3 add-product">
                                <label className="form-label">SKU</label>
                                <input
                                  className="form-control"
                                  type="text"
                                  placeholder="Enter SKU"
                                  name="ProductSKU"
                                  value={editformData.ProductSKU || ""}
                                  onChange={handleChange}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="add-product-new">
                          <div className="row">
                            {/* <div className="col-lg-4 col-sm-6 col-12">
                            <div className="mb-3 add-product">
                              <label className="form-label">Image</label>
                              <input
                                className="form-control"
                                type="file"
                                onChange={handleFileChange}
                              />
                            </div>
                          </div> */}
                            <div className="col-lg-4 col-sm-6 col-12">
                              <div className="mb-3 add-product">
                                <label className="form-label">Price</label>
                                <input
                                  className="form-control"
                                  type="text"
                                  placeholder="Enter average price"
                                  name="AvgPrice"
                                  value={editformData.AvgPrice || ""}
                                  onChange={handleChange}
                                />
                              </div>
                            </div>

                            <div className="col-lg-4 col-sm-12 col-12">
                              <div className="input-blocks">
                                <label>Variant Type</label>
                                <div className="row">
                                  <div className="col-lg-12 col-sm-12 col-12">
                                    <Select
                                      isMulti
                                      className="select"
                                      // styles={customStyles}
                                      styles={{
                                        multiValue: (base) => ({
                                          ...base,
                                          borderRadius: "8px",
                                          backgroundColor: "#007bff",
                                        }),
                                        multiValueLabel: (base) => ({
                                          ...base,
                                          color: "#fff",
                                          borderRadius: "5px",
                                        }),
                                      }}
                                      options={variantTypeData?.map(
                                        (store) => ({
                                          value: store.ItemId,
                                          label: store.ItemValue,
                                        })
                                      )}
                                      placeholder="Choose"
                                      onChange={handleVariantTypeSelectChange}
                                      value={selectedVType}
                                    />
                                  </div>
                                  {/* <div className="col-lg-2 col-sm-2 col-2 ps-0">
                                  <div className="add-icon">
                                    <Link
                                      to="#"
                                      className=""
                                      data-bs-toggle="modal"
                                      data-bs-target="#add-units"
                                    >
                                      <PlusCircle className="plus" />
                                    </Link>
                                  </div>
                                </div> */}
                                </div>
                              </div>
                            </div>

                            <div className="col-lg-4 col-sm-12 col-12">
                              <div className="input-blocks">
                                <label>Sale Unit</label>
                                <Myselect
                                  className="w-100 h-100"
                                  options={unitsData?.map((store) => ({
                                    value: store.ItemId,
                                    label: store.ItemValue,
                                  }))}
                                  placeholder="Choose"
                                  onChange={handleSaleUnitSelectChange}
                                  value={editformData?.SaleUnitId || null}
                                />
                              </div>
                            </div>

                            <div className="col-lg-4 col-sm-12 col-12">
                              <div className="input-blocks">
                                <label>Purchase Unit</label>
                                <Myselect
                                  className="w-100 h-100"
                                  options={unitsData?.map((store) => ({
                                    value: store.ItemId,
                                    label: store.ItemValue,
                                  }))}
                                  placeholder="Choose"
                                  onChange={handlePurUnitSelectChange}
                                  value={editformData?.PurchaseUnitId || null}
                                />
                              </div>
                            </div>
                          </div>

                          {/* Editor */}
                          <div className="col-lg-12">
                            <div className="input-blocks summer-description-box transfer mb-3">
                              <label>Description</label>
                              <textarea
                                className="form-control h-100"
                                rows={5}
                                placeholder="Enter product description"
                                name="Description"
                                value={editformData.Description || ""}
                                onChange={handleChange}
                              />
                              <p className="mt-1">Maximum 60 Characters</p>
                            </div>
                          </div>
                          {/* /Editor */}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    className={`accordion-card-one accordion ${
                      [1, 2, 4].includes(userDataSession.RoleId) ? "" : "d-none"
                    }`}
                    id="accordionExample2"
                  >
                    <div className="accordion-item">
                      <div
                        id="collapseTwo"
                        className=" d-flex"
                        aria-labelledby="headingTwo"
                        data-bs-parent="#accordionExample2"
                      >
                        <div className="accordion-body me-5">
                          <label className="d-block">Sold By</label>
                          <div className="input-block add-lists d-flex">
                            <label className="checkboxs">
                              <input
                                type="checkbox"
                                name="each"
                                checked={editformData.SoldbyWeight === false} // Check "Each" if SoldbyWeight is false
                                onChange={handleSoldByChange}
                              />
                              <span className="checkmarks" />
                              Each
                            </label>
                            <label className="checkboxs ms-4">
                              <input
                                type="checkbox"
                                name="weight"
                                checked={editformData.SoldbyWeight === true} // Check "Weight" if SoldbyWeight is true
                                onChange={handleSoldByChange}
                              />
                              <span className="checkmarks" />
                              Weight
                            </label>
                          </div>
                        </div>
                        <div className="accordion-body ms-5">
                          <label className="d-block">Product Type</label>
                          <div className="input-block add-lists d-flex">
                            <label className="checkboxs">
                              <input
                                type="checkbox"
                                name="TrackStock"
                                checked={editformData.TrackStock === true}
                                onChange={handleCheckboxChange}
                              />
                              <span className="checkmarks" />
                              Track Stock
                            </label>
                            <label className="checkboxs ms-4">
                              <input
                                type="checkbox"
                                name="IsCompositeItem"
                                checked={editformData.IsCompositeItem === true}
                                onChange={handleCompositeCheckbox}
                              />
                              <span className="checkmarks" />
                              Combo Product
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="d-flex align-items-center justify-content-between mb-3 p-3 border rounded shadow-sm bg-white">
                    <div className="me-3">
                      <label className="form-label fw-bold">
                        Product Image
                      </label>
                      <input
                        className="form-control"
                        type="file"
                        onChange={handleFileChange}
                      />
                    </div>

                    <div className="d-flex align-items-center">
                      {editformData.ImagePath ? (
                        <img
                          src={`${IMAGE_URL_IBIZ}${editformData.ImagePath}`}
                          alt="Product"
                          style={imageStyle}
                          onMouseEnter={() => setIsHovered(true)}
                          onMouseLeave={() => setIsHovered(false)}
                        />
                      ) : (
                        <div
                          className="d-flex justify-content-center align-items-center rounded-circle shadow-sm"
                          style={{
                            width: "50px",
                            height: "50px",
                            backgroundColor: "#FF9F43",
                            marginRight: "10px",
                            fontSize: "18px",
                            fontWeight: "bold",
                            color: "#fff",
                          }}
                        >
                          {editformData.Name
                            ? getFirstLetter(editformData.Name)
                            : "N/A"}
                        </div>
                      )}
                      <span className="fw-bold text-dark">
                        {editformData.Name}
                      </span>
                    </div>
                  </div>
                  <div
                    className="accordion-card-one accordion"
                    id="accordionExample4"
                  >
                    <div className="accordion-item">
                      <div className="accordion-header" id="headingFour">
                        <div
                          className="accordion-button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseFour"
                          aria-controls="collapseFour"
                        >
                          <div className="text-editor add-list">
                            <div className="addproduct-icon list">
                              <h5>
                                <List className="add-info" />
                                <span>Stores</span>
                              </h5>
                              <Link to="#">
                                <ChevronDown className="chevron-down-add" />
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        id="collapseFour"
                        className="accordion-collapse collapse show"
                        aria-labelledby="headingFour"
                        data-bs-parent="#accordionExample4"
                      >
                        <div className="accordion-body">
                          <div className="text-editor add-list add">
                            <div className="row">
                              <div className="col-lg-12 col-sm-12 col-12">
                                <div
                                  className="table-responsive"
                                  style={{ height: "20rem", overflowY: "auto" }}
                                >
                                  <table className="table datanew dataTable no-footer">
                                    <thead className="sticky-top">
                                      <tr>
                                        <th>#</th>
                                        <th>For Sale</th>
                                        <th>Store Name</th>
                                        <th>Tax</th>
                                        <th>Price</th>
                                        <th>Price inc Tax</th>
                                        <th>Low Stock</th>
                                        <th>Optimal Stock</th>
                                        <th>Current Stock</th>
                                        <th>Add/Adj Stock</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {storeEditFormData.map(
                                        (storeData, index) => (
                                          <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td className="text-center">
                                              <input
                                                type="checkbox"
                                                checked={storeData.IsForSale}
                                                onChange={handleForSaleCheckbox(
                                                  index
                                                )}
                                                style={{ cursor: "pointer" }}
                                              />
                                            </td>
                                            <td>{userStores[index].Name}</td>
                                            <td>
                                              <select
                                                className="form-select"
                                                onChange={handleStoreCheckboxChange(
                                                  index,
                                                  "taxId"
                                                )}
                                                value={storeData.taxId}
                                              >
                                                <option value="">Choose</option>
                                                {taxesData?.map((tax) => (
                                                  <option
                                                    key={tax.Id}
                                                    value={tax.Id}
                                                  >
                                                    {tax.TaxRate}%
                                                  </option>
                                                ))}
                                              </select>
                                            </td>
                                            <td>
                                              <input
                                                className="form-control"
                                                type="number"
                                                placeholder="Enter price"
                                                value={storeData.StorePrice}
                                                onChange={(event) =>
                                                  handleStorePriceChange(
                                                    index,
                                                    event
                                                  )
                                                }
                                                style={{ width: "6rem" }}
                                              />
                                            </td>
                                            <td className="text-center">
                                              <input
                                                type="checkbox"
                                                checked={
                                                  storeData.PriceInclusiveTax
                                                }
                                                onChange={handlePriceIncTaxCheckbox(
                                                  index
                                                )}
                                                style={{ cursor: "pointer" }}
                                              />
                                            </td>
                                            <td>
                                              <input
                                                className="form-control"
                                                type="number"
                                                placeholder="0"
                                                value={storeData.LowStock}
                                                onChange={handleStoreCheckboxChange(
                                                  index,
                                                  "LowStock"
                                                )}
                                                onWheel={(e) =>
                                                  e.target.blur(e)
                                                }
                                                style={{ width: "5rem" }}
                                              />
                                            </td>
                                            <td>
                                              <input
                                                className="form-control"
                                                type="number"
                                                placeholder="0"
                                                value={storeData.OptimalStock}
                                                disabled
                                                onChange={handleStoreCheckboxChange(
                                                  index,
                                                  "OptimalStock"
                                                )}
                                                style={{ width: "5rem" }}
                                              />
                                            </td>
                                            <td>
                                              <input
                                                className="form-control"
                                                type="number"
                                                placeholder="0"
                                                value={storeData.InStock}
                                                disabled
                                                onChange={handleStoreCheckboxChange(
                                                  index,
                                                  "InStock"
                                                )}
                                                style={{ width: "5rem" }}
                                              />
                                            </td>
                                            <td>
                                              <input
                                                className="form-control"
                                                type="number"
                                                placeholder="0"
                                                value={storeData.addAdjStock}
                                                onChange={handleStoreCheckboxChange(
                                                  index,
                                                  "addAdjStock"
                                                )}
                                                onWheel={(e) =>
                                                  e.target.blur(e)
                                                }
                                                style={{ width: "5rem" }}
                                              />
                                            </td>
                                          </tr>
                                        )
                                      )}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-12">
                <div className="btn-addproduct mb-4 ">
                  <button
                    type="submit"
                    className="btn btn-submit me-2 mt-2 rounded"
                  >
                    {submitBtnLoading ? "Submitting..." : "Save Product"}
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
        <Addunits />
        <AddCategoryList />
        <AddSubcategory />
        <AddBrand />
        <AddVariant />
      </div>
    </>
  );
};

export default EditProduct;
